import _ from "lodash";
import {conditionalClass} from "../../Utils/Helpers";

export default class SingleItem {
    #$item;

    constructor(item) {
        this.#$item = item;
    }

    render() {
        return `<div class="col-sm-12 col-md-6 col-lg-4 col-xl-3 p-0">
                    <div class="${conditionalClass('product-item p-3 position-relative', {'unavailable-product': !this.#isMarketable()})}">
                        ${this.#header()}
                        <div class="product-item-thumbnail text-center mb-3 position-relative">
                            ${this.#thumbnail()}
                            ${this.#actions()}
                        </div>
                        <div class="product-item-details">
                            <a target="_blank" href="${_.get(this.#$item, 'url.base')}">
                                <h5 class="fs-7 product-item-title">${_.get(this.#$item, 'title')}</h5>
                            </a>
                        </div>
                        <div class="product-item-prices mt-3">
                            ${this.#price()}
                        </div>
                        <a title="${_.get(this.#$item, 'title')}" target="_blank" href="${_.get(this.#$item, 'url.base')}" class="stretched-link"></a>
                    </div>
                </div>`;
    }

    #header() {
        if (!this.#isMarketable()) {
            return `<div class="product-item-head">
                        <div class="unavailable-badge">ناموجود</div>
                    </div>`;
        } else if (this.#hasDiscount()) {
            return `<div class="product-item-head">
                        <div class="discount-badge">${_.get(this.#$item, 'price.percentage_discount')}٪</div>
                    </div>`;
        }

        return '';
    }

    #thumbnail() {
        const photo = _.get(this.#$item, 'photo') || {url: '/static/images/none-picture.jpg', alt: 'img-loading'};

        return `<a class="thumbnail-wrapper" target="_blank" href="${_.get(this.#$item, 'url.base')}">
                    <img loading="lazy" src="${_.get(photo, 'url')}" alt="${_.get(photo, 'alt')}" class="object-contain">
                </a>`;
    }

    #category() {
        const category = _.first(_.get(this.#$item, 'categories'))
        return `<a class="product-meta" href="${_.get(category, 'uri')}">${_.get(category, 'title')}</a>`;
    }

    #price() {
        if (!this.#isMarketable()) {
            return `<div class="unavailable-label">ناموجود</div>`
        }

        const price = _.get(this.#$item, 'price')
        let price_box = '';

        if (this.#hasDiscount()) {
            price_box += `<div class="discounted">${_.get(price, 'price_discounted_formatted')}</div>`;
        }
        price_box += `<div class="base">${_.get(price, 'original_price_formatted')}</div>`;


        return price_box;
    }

    #actions() {
        return `<div class="product-item-actions" data-item="${_.get(this.#$item, 'id')}">
                    <div class="product-item-cart-btn">
                        ${this.#cartAction()}
                    </div>
                </div>`;
    }

    #cartAction() {
        const url = _.get(this.#$item, 'url')

        if (!this.#isMarketable()) {
            return `<button
                data-href="#"
                data-remove-cart="#"
                class="btn btn-sm w-100 invisible">ناموجود</button>`
        }

        if (this.#hasCart()) {
            return `<button
                data-href="${_.get(url, 'remove_cart')}"
                data-add-cart="${_.get(url, 'add_to_cart')}"
                class="btn btn-sm w-100 js-cart-btn-remove-item"><i class="fad fa-trash-alt"></i> حذف از سبد خرید</button>`
        }

        return `<button
                    data-href="${_.get(url, 'add_to_cart')}"
                    data-remove-cart="${_.get(url, 'remove_cart')}"
                    class="btn btn-sm w-100 js-btn-add-to-cart"><i class="fad fa-cart-plus"></i> افزودن به سبد خرید</button>`
    }

    #hasDiscount() {
        return _.get(this.#$item, 'properties.has_discounted')
    }

    #isMarketable() {
        return _.get(this.#$item, 'properties.is_marketable')
    }

    #hasCart() {
        return _.get(this.#$item, 'properties.is_exist_in_cart')
    }
}